import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Box, Typography, IconButton, Drawer, List, ListItem, ListItemText, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Img1 from '../../img/energia solar a tu altura.svg';
import Img2 from '../../img/rayo energy.svg';
const Navbar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const navItems = [
        { name: 'INICIO', path: '/' },
        { name: '¿QUIENES SOMOS?', path: '/about' },
        { name: 'SISTEMAS', path: '/systems' },
        { name: 'CASOS DE ÉXITO', path: '/success-cases' },
        { name: 'SERVICIOS', path: '/services' },
    ];

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center', width: 280 }}>
            <List>
                {navItems.map((item) => (
                    <ListItem
                        button
                        key={item.name}
                        component={Link}
                        to={item.path}
                        sx={{
                            color: location.pathname === item.path ? '#D5C347' : 'white',
                            '&:hover': {
                                backgroundColor: '#424242',
                            },
                            py: 2,
                            fontFamily: 'Montserrat, sans-serif',
                        }}
                    >
                        <ListItemText
                            primary={item.name}
                            primaryTypographyProps={{
                                fontFamily: 'Montserrat, sans-serif',
                                fontWeight: 600,
                                fontSize: '1.1rem',
                                letterSpacing: '1px'
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: '#313131',
                fontFamily: 'Montserrat, sans-serif'
            }}
        >
            <Toolbar sx={{
                justifyContent: 'space-between',
                px: { xs: 2, md: 4 }
            }}>
                {/* Logo e imágenes */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* Reemplaza con tu imagen */}
                    <Box
                        component="img"
                        src={Img1}
                        alt="Imagen decorativa"
                        sx={{
                            height: 120,
                            mr: 2,
                            display: { xs: 'none', md: 'block' }
                        }}
                    />
                    {/* Logo */}
                    <Box
                        component="img"
                        src={Img2}
                        alt="Logo"
                        sx={{
                            height: { xs: 90, md: 105 },
                            mr: { xs: 5, md: 0 }
                        }}
                    />
                </Box>

                {/* Menú de navegación */}
                {isMobile ? (
                    <>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ ml: 'auto' }}
                        >
                            <MenuIcon sx={{ fontSize: '2rem' }} />
                        </IconButton>
                        <Drawer
                            anchor="right"
                            open={mobileOpen}
                            onClose={handleDrawerToggle}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            sx={{
                                '& .MuiDrawer-paper': {
                                    backgroundColor: '#313131',
                                    boxSizing: 'border-box',
                                },
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </>
                ) : (
                    <Box sx={{
                        display: 'flex',
                        gap: { md: 4, lg: 6 },
                        ml: 'auto'
                    }}>
                        {navItems.map((item) => (
                            <Typography
                                key={item.name}
                                component={Link}
                                to={item.path}
                                sx={{
                                    color: location.pathname === item.path ? '#D5C347' : 'white',
                                    textDecoration: 'none',
                                    fontWeight: 600,
                                    fontSize: '1.1rem',
                                    letterSpacing: '1px',
                                    '&:hover': {
                                        color: '#D5C347',
                                    },
                                    fontFamily: 'Montserrat, sans-serif',
                                    px: 1,
                                    py: 1,
                                    position: 'relative',
                                    '&:after': {
                                        content: '""',
                                        position: 'absolute',
                                        bottom: 0,
                                        left: 0,
                                        width: location.pathname === item.path ? '100%' : '0%',
                                        height: '2px',
                                        backgroundColor: '#D5C347',
                                        transition: 'width 0.3s ease'
                                    },
                                    '&:hover:after': {
                                        width: '100%'
                                    }
                                }}
                            >
                                {item.name}
                            </Typography>
                        ))}
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;